import { useState } from 'react';
import { Plus } from 'lucide-react';

export function EmptyMealSlot({ mealType, onAdd, compact = false }) {
  const [isCompactHovered, setIsCompactHovered] = useState(false);

  if (compact) {
    return (
      <div className="flex min-h-10 items-center justify-between rounded-2xl border border-[#E7E1D6] bg-[#F7F5F1] px-2 py-2">
        <p className="mb-0 text-gray-500 leading-none">
          {mealType}
        </p>
        <button
          type="button"
          onClick={() => onAdd(mealType)}
          onMouseEnter={() => setIsCompactHovered(true)}
          onMouseLeave={() => setIsCompactHovered(false)}
          onFocus={() => setIsCompactHovered(true)}
          onBlur={() => setIsCompactHovered(false)}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full shadow-sm transition-all duration-200"
          style={{ backgroundColor: isCompactHovered ? 'var(--primary)' : '#FFFFFF' }}
          aria-label={`Add ${mealType}`}
        >
          <Plus
            className="w-3.5 h-3.5 transition-colors"
            style={{ color: isCompactHovered ? '#FFFFFF' : '#525252' }}
          />
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => onAdd(mealType)}
      className="w-full bg-white rounded-3xl p-4 shadow-sm hover:shadow-md transition-all border-2 border-dashed border-gray-200 hover:border-[#7B9EC6] group"
    >
      <div className="flex items-center gap-4">
        <div className="w-20 h-20 rounded-2xl bg-gray-50 flex items-center justify-center flex-shrink-0 group-hover:bg-[#7B9EC6]/10 transition-colors">
          <Plus className="w-8 h-8 text-gray-300 group-hover:text-[#7B9EC6] transition-colors" />
        </div>
        
        <div className="flex-1 text-left">
          <p className="text-[#757575] group-hover:text-[#7B9EC6] transition-colors">Add {mealType}</p>
        </div>
      </div>
    </button>
  );
}
